import React from 'react';

function formatDisplayDate(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export default function TimeSlots({ slots, onUpdateSlot, onRemoveSlot }) {
  if (slots.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '24px', color: 'var(--text-muted)' }}>
        <p style={{ fontSize: '0.9rem' }}>Click dates on the calendar to add them</p>
      </div>
    );
  }

  return (
    <div>
      {slots.map((slot, idx) => (
        <div key={slot.date} className="time-slot fade-in">
          <div className="date-label">{formatDisplayDate(slot.date)}</div>
          <input
            type="time"
            value={slot.start_time}
            onChange={e => onUpdateSlot(idx, 'start_time', e.target.value)}
            aria-label={`Start time for ${slot.date}`}
          />
          <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>to</span>
          <input
            type="time"
            value={slot.end_time}
            onChange={e => onUpdateSlot(idx, 'end_time', e.target.value)}
            aria-label={`End time for ${slot.date}`}
          />
          <button
            type="button"
            className="remove-btn"
            onClick={() => onRemoveSlot(idx)}
            aria-label={`Remove ${slot.date}`}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
